export const POLL_DATA_TYPE_MAP = {
	number: 'number',
	percentage: 'percentage'
};

export type PollDataType = keyof typeof POLL_DATA_TYPE_MAP;

export const POLL_DATA_GROUP_BY_MAP = {
	response: 'poll response choice',
	dataset: 'data set'
};

export type PollDataGroupByType = keyof typeof POLL_DATA_GROUP_BY_MAP;

export const POLL_CHOICE_ORDERING_MAP = {
	fixed: 'fixed (as authored)',
	popularity_asc: 'popularity (asc)',
	popularity_desc: 'popularity (desc)'
};

export type PollChoiceOrderingType = keyof typeof POLL_CHOICE_ORDERING_MAP;

export const POLL_COLOR_GROUP_BY_MAP = {
	response: 'response choice',
	dataset: 'data set'
};

export type PollColorGroupByType = keyof typeof POLL_COLOR_GROUP_BY_MAP;

export type PollChartType = 'bar' | 'pie';
